import { LoginClientLink } from 'links/login/client'
import { MyAccountClientLink } from 'links/myAccount/client'

export enum SessionMapKey {
	Logged = 'logged',
	NotLogged = 'notLogged',
}

export type SessionMap = {
	text: string
	accessibilityText: string
	Component: typeof MyAccountClientLink | typeof LoginClientLink
}

type SessionMapper = Record<SessionMapKey, SessionMap>

export const SESSION_MAP: SessionMapper = {
	[SessionMapKey.Logged]: {
		text: 'header.myAccount.text',
		accessibilityText: 'accessibility.header.myAccount.icon',
		Component: MyAccountClientLink,
	},
	[SessionMapKey.NotLogged]: {
		text: 'header.myAccount.pushLogin.text',
		accessibilityText: 'accessibility.header.myAccount.pushLogin.icon',
		Component: LoginClientLink,
	},
}
